import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RepresentacaoEmpresa } from '../api';

@Injectable({
  providedIn: 'root'
})
export class RepresentacaoEmpresaService {
  private readonly path = 'Profissionais';
  public params = new HttpParams();

  constructor(private apiService: ApiService) {}

  // List all RepresentacaoEmpresa
  list(params?: any): Observable<any> {
    return this.apiService.get<{ data: RepresentacaoEmpresa[] }>(`${this.path}/getAllRepresentacaoEmpresa`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    true // <- força o uso da URL secundária
    ).pipe(
        map(response => response)
    );
  }

  // Get RepresentacaoEmpresa by ID
  public show(id: string): Observable<RepresentacaoEmpresa> {
    return this.apiService.get<{ data: RepresentacaoEmpresa }>(`${this.path}/getRepresentacaoEmpresaById/${id}`,
    new HttpParams(),
    true // <- força o uso da URL secundária
    ).pipe(
      map(response => response.data)
    );
  }

  // Create new RepresentacaoEmpresa
  public store(formData: FormData): Observable<any> {
    return this.apiService.post(
      `/AddRepresentacaoEmpresa`,
      formData,
      undefined,
      true // URL secundária
    );
  }

  // Update existing RepresentacaoEmpresa
  public update(formData: FormData, id: string): Observable<any> {
    return this.apiService.put(`${this.path}/UpdateRepresentacaoEmpresa/`, formData,
      undefined,
      true // URL secundária
    )
  }

  // Delete existing RepresentacaoEmpresa
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteRepresentacaoEmpresaById/${id}`,
        new HttpParams(),
        true // URL secundária
    );
  }

   // get photo Empresa do sector
   getPhotoRepresentanteIdGet(id: number): Observable<Blob> {
    return this.apiService.get(`${this.path}/getPhotoRepresentacaoEmpresa/${id}`,
      new HttpParams(),
      true,
      'blob',
    );
  }
}